<template>
  <div class="all_part" @click="bar_notShow">
    <div class="head">
      <div class="back" v-show="this.$store.state.pan_CloseNotShow==0"></div>
      <div class="back" @click="back" v-show="this.$store.state.pan_CloseNotShow==1">
        <img src="../assets/main_menu_Phone/back.png" alt="" width="25px"/>
      </div>
      <div class="titleAndicon">
        <div class="titleName">
          <span>价格与库存</span>
        </div>
        <div class="title_icon" @click="navbarShow" @click.stop>
          <img src="../assets/ProductTablePhone_img/icon.png" alt="" width="30px"/>
        </div>
      </div>
    </div>
    <div class="heads" v-if="PanDuanShou">
      <div class="heads_menus" v-if="user_leave.standardType == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/JiaGeKuCun.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="Second_jiage">
          <span>价格与库存</span>
        </div>
      </div>
      <dir class="heads_menu" v-if="user_leave.master_gear == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/ICChanPinXinXi.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="Second_ZhuDang">
          <span>IC市场信息</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.competitive_products == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/NeiBuXieTiao.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="TableInputPhone">
          <span>IC市场情报</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.task == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/JiaGeKuCun.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="NeiBuXieTiao">
          <span>内部协调</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.financeType == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/YingShouKuanYuFaPiao.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="FinancePhone">
          <span>应收款与发票</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.orderType == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/YingShouKuanYuFaPiao.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="DingDanZhongXin">
          <span>订单中心</span>
        </div>
      </dir>
    </div>
    <div class="input_button">
      <div class="ss"></div>
      <div :class="PanDuanShous ? 'all_inputs' : 'all_input'">
        <div :class="PanDuanShous ? 'all_input_top' :' all_input_tops' ">
          <div class="input">
            <el-input
                v-model="newItemNo"
                placeholder="新旧料号 | 询价单号"
                style="width: 180px"
            ></el-input>
          </div>
          <div>
            <div class="submit_button">
              <div class="all_firstbutton">
                <div class="search_buttons">
                  <div class="sousuoButton">
                    <el-button
                        type="primary"
                        @click="serchChanPin"
                        style="
                  height: 32pt;
                  width:70pt;
                  background-image: linear-gradient(to right, #358fe5, #1d6eb9);
                "
                    >搜索
                    </el-button>
                    <div class="sousuo_icon">
                      <img src="../assets/SouSuo.png" alt="" width="14pt"/>
                    </div>
                  </div>
                </div>
                <div class="all_second_button">
                  <div class="ChongZhi">
                    <div class="second_button" @click="clearInput">
                      <el-button
                          plain
                          type="primary"
                          style="height: 32pt; width: 56pt;"
                      >重置
                      </el-button>
                      <div class="icon_chong">
                        <img src="../assets/ChongZhi.png" alt="" width="14pt"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--          <div class="ChaKianQingDan">-->
              <!--            <div-->
              <!--                class="second_button"-->
              <!--                @click="clearInput"-->
              <!--                style="margin-bottom: 10px"-->
              <!--            >-->
              <!--&lt;!&ndash;              <el-button&ndash;&gt;-->
              <!--&lt;!&ndash;                  @click="serchGouWuChe"&ndash;&gt;-->
              <!--&lt;!&ndash;                  plain&ndash;&gt;-->
              <!--&lt;!&ndash;                  type="primary"&ndash;&gt;-->
              <!--&lt;!&ndash;                  style="width: 122px; height: 34pt; font-size: 16px"&ndash;&gt;-->
              <!--&lt;!&ndash;              >查看清单&ndash;&gt;-->
              <!--&lt;!&ndash;              </el-button>&ndash;&gt;-->
              <!--              <div class="icon_chong">-->
              <!--                <img src="../assets/ChongZhi.png" alt="" width="14pt"/>-->
              <!--              </div>-->
              <!--            </div>-->
              <!--            <div-->
              <!--                class="second_button"-->
              <!--                @click="clearInput"-->
              <!--                style="margin-bottom: 10px"-->
              <!--            >-->
              <!--              <el-button-->
              <!--                  @click="clearall"-->
              <!--                  plain-->
              <!--                  type="primary"-->
              <!--                  style="width: 122px; height: 34pt; font-size: 16px"-->
              <!--              >清空清单-->
              <!--              </el-button>-->
              <!--              <div class="icon_chong">-->
              <!--                <img src="../assets/ChongZhi.png" alt="" width="14pt"/>-->
              <!--              </div>-->
              <!--            </div>-->
              <!--            <div class="second_button" @click="download">-->
              <!--              <div>-->
              <!--                <el-button-->

              <!--                    plain-->
              <!--                    type="primary"-->
              <!--                    style="width: 122px; height: 34pt; font-size: 16px"-->
              <!--                >导出清单-->
              <!--                </el-button>-->
              <!--              </div>-->
              <!--            </div>-->
              <!--          </div>-->
            </div>
          </div>
        </div>
        <div class="Not_show" v-if="PanDuanShous">
          <div>
            <!--            产品大类-->
            <div class="input">
              <el-select
                  v-model="ChanPinDaLei_choice"
                  placeholder="产品大类"
                  style="width: 180px"
              >
                <el-option
                    v-for="item in ChanPinDaLei_Select"
                    :key="item.value"
                    :label="item.category_big"
                    :value="item.category_big"
                    @click="this.serchChanPinXiaoLei()"
                >
                </el-option>
              </el-select>
            </div>
            <!--            内径-->
            <div class="input">
              <el-input
                  v-model="internal_meridian"
                  placeholder="内径"
                  style="width: 180px"
              ></el-input>
            </div>
            <!--            材质-->
            <div class="input">
              <el-select
                  @change="change('b', CaiZhi_choice)"
                  v-model="CaiZhi_choice"
                  placeholder="材质"
                  style="width: 180px"
              >
                <el-option
                    v-for="item in CaiZhi_select"
                    :key="item.value"
                    :label="item.material"
                    :value="item.material"
                >
                </el-option>
              </el-select>
            </div>
            <!--            标准代码-->
            <div class="input">
              <el-select
                  filterable
                  v-model="BiaoZhun_Choice"
                  placeholder="标准代码"
                  style="width: 180px"
              >
                <el-option
                    v-for="item in BiaoZhun_Select"
                    :key="item.value"
                    :label="item.standard_code"
                    :value="item.standard_code"
                >
                </el-option>
              </el-select>
            </div>
            <!--              硬度-->
            <div class="input">
              <el-select
                  v-model="YingDu_Choice"
                  placeholder="硬度"
                  style="width: 180px"
              >
                <el-option
                    v-for="item in YingDu_Select"
                    :key="item.value"
                    :label="item"
                    :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div>
            <!--            产品小类-->
            <div class="input">
              <el-select
                  v-model="ChanPinXiaoLei_choice"
                  placeholder="产品小类"
                  style="width: 180px"
              >
                <el-option
                    v-for="item in ChanPinXiaoLei_Select"
                    :key="item.value"
                    :label="item.category_small"
                    :value="item.category_small"
                >
                </el-option>
              </el-select>
            </div>
            <!--               线径-->
            <div class="input">
              <el-input
                  v-model="wire_diameter"
                  placeholder="线径"
                  style="width: 180px"
              ></el-input>
            </div>
            <!--            材质代码-->
            <div class="input">
              <el-select
                  v-model="CaiLiaoXinXi_Code_Choice"
                  placeholder="材质代码"
                  style="width: 180px"
              >
                <el-option
                    v-for="item in CaiLiaoXinXi_Code_Select"
                    :key="item.value"
                    :label="item.material_code"
                    :value="item.material_code"
                >
                </el-option>
              </el-select>
            </div>

            <!--            颜色-->
            <div class="input">
              <el-select
                  v-model="YanSe_Choice"
                  placeholder="颜色"
                  style="width: 180px"
              >
                <el-option
                    v-for="item in YanSe_Select"
                    :key="item.value"
                    :label="item.color"
                    :value="item.color"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div :class="PanDuanShous ? 'ShouQi':'ShouQis'" @click="inputShow">
          <img src="../assets/ProductTablePhone_img/组 3.png" alt=""/>
        </div>
      </div>
    </div>
    <div :class="PanDuanShous ? 'all_spans2':'all_spans'">
      <div class="all_key">
        <div v-for="(item, i) in tableData" class="list_div">
          <div class="Key">
            <span class="There_span">新料号</span>
            <span>{{ item.newItemNo }}</span>
          </div>
          <div class="Key">
            <span class="There_span">旧料号</span>
            <span>{{ item.oldMaterialNo }}</span>
          </div>
          <div class="Key">
            <span style="letter-spacing: 4px">IS库存</span>
            <span>{{ item.shanghai_stock }}</span>
          </div>
          <div class="Key">
            <span>工厂库存</span>
            <span>{{ item.taiwan_stock }}</span>
          </div>
          <div class="Key">
            <span>在途总量</span>
            <span>{{ item.transport }}</span>
          </div>
          <div class="Key">
            <span>材料编号</span>
            <span>{{ item.material_number }}</span>
          </div>
          <div class="Key">
            <span class="two_span_font">内径</span>
            <span>{{ item.internal_meridian }}</span>
          </div>
          <div class="Key">
            <span class="two_span_font">线径</span>
            <span>{{ item.wire_diameter }}</span>
          </div>
          <div class="list_div_divsss">
            <div class="list_div_div" v-if="item.child==[]">
              <div class="Key">
                <span style="letter-spacing: 25px">MOQ</span>
                <span>{{ item.MOQ }}</span>
              </div>
              <div class="Key">
                <span class="There_span">包装量</span>
                <span>{{ item.packing_quantity }}</span>
              </div>
              <div class="Key">
                <span class="two_span_font">面价</span>
                <span>{{ item.money }}</span>
              </div>
              <div class="Key">
                <span>工程师</span>
                <span>{{ item.executive_director }}</span>
              </div>
              <div class="Key">
                <span>主管/客户经理/销售经理</span>
                <span>{{ item.sales_manager }}</span>
              </div>
              <div class="Key">
                <span>区域经理/部门经理</span>
                <span>{{ item.industry_manager }}</span>
              </div>
            </div>
            <div  class="list_div_divsses">
              <div class="Keyssss">
                <span> MOQ </span>
                <span class="There_span">包装量</span>
                <span class="two_span_font">面价</span>
                  <span class="There_span" v-if="user_leave.suggestedPriceType == 1">分包价</span>
                <span> 主管/客户经理/销售经理</span>
                <span>区域经理/部门经理</span>
                <span>工程师</span>
              </div>
              <div class="Keys" v-for="(item,index) in item.child "v-show="index<=3">
                <span>{{ item.MOQ}}</span>
                <span>{{item.packing_quantity }}</span>
                <span>{{ item.money }}</span>
                <span>{{ item.suggested_price }}</span>
                <span>{{ item.sales_manager }}</span>
                <span>{{ item.industry_manager }}</span>
                <span>{{ item.executive_director }}</span>
              </div>
            </div>
          </div>
          <div class="list_div_divsss" v-show="item.child<=3||item.child>1">
            <div class="list_div_div" v-if="item.child==[]">
              <div class="Key">
                <span style="letter-spacing: 25px">MOQ</span>
                <span>{{ item.MOQ }}</span>
              </div>
              <div class="Key">
                <span class="There_span">包装量</span>
                <span>{{ item.packing_quantity }}</span>
              </div>
              <div class="Key">
                <span class="two_span_font">面价</span>
                <span>{{ item.money }}</span>
              </div>
              <div class="Key">
                <span>工程师</span>
                <span>{{ item.executive_director }}</span>
              </div>
              <div class="Key">
                <span>主管/客户经理/销售经理</span>
                <span>{{ item.sales_manager }}</span>
              </div>
              <div class="Key">
                <span>区域经理/部门经理</span>
                <span>{{ item.industry_manager }}</span>
              </div>
            </div>
            <div  class="list_div_divss">
              <div class="Keys">
                <span> MOQ</span>
                <span class="There_span">包装量</span>
                <span class="two_span_font">面价</span>

                  <span class="There_span" v-if="user_leave.suggestedPriceType == 1">分包价</span>

                <span> 主管/客户经理/销售经理</span>
                <span>区域经理/部门经理</span>
                <span>工程师</span>
              </div>
              <div class="Keys" v-for="(item,index) in item.child "v-show="index<3">
                <span>{{ item.MOQ }}</span>
                <span>{{item.packing_quantity }}</span>
                <span>{{ item.money }}</span>
                <span>{{ item.suggested_price }}</span>
                <span>{{ item.sales_manager }}</span>
                <span>{{ item.industry_manager }}</span>
                <span>{{ item.executive_director }}</span>
              </div>
            </div>
          </div>
          <div class="list_div_divsss" v-show="item.child.length>=4">
            <div class="list_div_div" v-if="item.child==[]">
              <div class="Key">
                <span style="letter-spacing: 25px">MOQ</span>
                <span>{{ item.MOQ }}</span>
              </div>
              <div class="Key">
                <span class="There_span">包装量</span>
                <span>{{ item.packing_quantity }}</span>
              </div>
              <div class="Key">
                <span class="two_span_font">面价</span>
                <span>{{ item.money }}</span>
              </div>
              <div class="Key">
                <span>工程师</span>
                <span>{{ item.executive_director }}</span>
              </div>
              <div class="Key">
                <span>主管/客户经理/销售经理</span>
                <span>{{ item.sales_manager }}</span>
              </div>
              <div class="Key">
                <span>区域经理/部门经理</span>
                <span>{{ item.industry_manager }}</span>
              </div>
            </div>
            <div  class="list_div_divss">
              <div class="Keys">
                <span> MOQ</span>
                <span class="There_span">包装量</span>
                <span class="two_span_font">面价</span>
                <span class="There_span" v-if="user_leave.suggestedPriceType == 1">分包价</span>
                <span> 主管/客户经理/销售经理</span>
                <span>区域经理/部门经理</span>
                <span>工程师</span>
              </div>
              <div class="Keys" v-for="(item,index) in item.child "v-show="index>=3">
                <span>{{ item.MOQ }}</span>
                <span>{{item.packing_quantity }}</span>
                <span>{{ item.money }}</span>
                <span>{{ item.suggested_price }}</span>
                <span>{{ item.sales_manager }}</span>
                <span>{{ item.industry_manager }}</span>
                <span>{{ item.executive_director }}</span>
              </div>

            </div>
          </div>
          <div class="Key">
            <span>标准代码</span>
            <span>{{ item.standard_code }}</span>
          </div>
          <!--        <div class="Key">-->
          <!--          材质:<span>{{ item.material }}</span>-->
          <!--        </div>-->
          <!--        <div class="Key">-->
          <!--          硬度:<span>{{ item.hardness }}</span>-->
          <!--        </div>-->


          <!-- <div class="Key">
            建议价:<span>{{ item.discount }}</span>
          </div> -->
          <!--          <div class="Key" v-if="user_leave.project_price == 1">-->
          <!--            项目价格:<span>{{ item.project_price }}</span>-->
          <!--          </div>-->
          <div class="Key">
            <span class="There_span">模具费</span>
            <span>{{ item.mould_cost }}</span>
          </div>
          <div class="Key">
            <span>其他费用</span>
            <span>{{ item.other_expenses }}</span>
          </div>
          <div class="Key">
            <span>生产周期</span>
            <span>{{ item.supplierNum }}(月)</span>
          </div>
          <!--          <div class="Key"  v-if="user_leave.productNumberType == 1">-->
          <!--            平台产品编号:<span>{{-->
          <!--              item.platform_number-->
          <!--            }}</span>-->
          <!--          </div>-->
          <!--          <div class="Key">-->
          <!--            询价单号:<span>{{ item.inquiry_no }}</span>-->
          <!--          </div>-->
          <!--          <div class="Key" v-if="user_leave.quotationNoType == 1">-->
          <!--            供应商报价单号:<span>{{-->
          <!--              item.quotation_no-->
          <!--            }}</span>-->
          <!--          </div>-->

          <!--          <div class="Key">-->
          <!--            其他说明:<span style="line-height: 16px">{{-->
          <!--              item.remarks-->
          <!--            }}</span>-->
          <!--          </div>-->
          <!-- <div class="Key">
            标准尺寸代码:<span
              class="list_div_span"
              style="line-height: 16px"
          >{{ item.standard_code }}</span
          >
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<!-- <div class="Key">
             <span>尺寸标准代码</span>
             <span>{{ item.standard_code }}</span>
           </div> -->
<script>
import {httpUrl} from "../components/publics";
// const clickoutside = {
//   // 初始化指令
//   bind(el, binding, vnode) {
//     function documentHandler(e) {
//       // 这里判断点击的元素是否是本身，是本身，则返回
//       if (el.contains(e.target)) {
//         return false;
//       }
//       // 判断指令中是否绑定了函数
//       if (binding.expression) {
//         // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
//         binding.value(e);
//       }
//     }
//     // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
//     el.__vueClickOutside__ = documentHandler;
//     document.addEventListener('click', documentHandler);
//   },
//   unbind(el, binding) {
//     // 解除事件监听
//     document.removeEventListener('click', el.__vueClickOutside__);
//     delete el.__vueClickOutside__;
//   },
// };
export default {
  name: "productTablePhone",
  data() {
    return {
      user_leave: {},
      PanDuanShous: false,
      PanDuanShou: false,
      tableData: [],
      newItemNo: "", //新料号
      oldMaterialNo: "", //旧料号
      internal_meridian: "", // 产品内径
      wire_diameter: "", //产品线径
      ChanPinXiaoLei_choice: "", //产品小类选择
      CaiZhi_choice: "", //材质选择   //material
      BiaoZhun_Choice: "", //标准选择
      YingDu_Choice: "", //硬度选择
      standard_code: "", //标准代码
      inquiry_no: "", //询价单号
      CaiLiaoXinXi_Code_Choice: "", //材料信息选择
      ChanPinDaLei_choice: "", // 产品大类选择
      YanSe_Choice: "", //颜色选择
      ChanPinDaLei_Select: [], // 产品大类下拉框
      ChanPinXiaoLei_Select: [], //产品小类下拉框
      CaiZhi_select: [], //材质选择拉下
      BiaoZhun_Select: [], //标准下拉框
      YingDu_Select: [], //硬度下拉框
      CaiLiaoXinXi_Code_Select: [], //材料信息下拉框
      YanSe_Select: [], //颜色下拉框
      page: "",
    };
  },
  watch: {
    ChanPinDaLei_choice(newName, oldName) {
      this.serchChanPinXiaoLei(newName);
    },
    CaiZhi_choice(newName, oldName) {
      this.serchCaiLiaoXinxi(newName);
      this.serchYanSe(newName);
    },
  },
  mounted() {
    // document.addEventListener('click', this.bodyCloseSelected)
    this.serchCaiZhi();
    this.getUser();
    this.serchChanPinDaLei();
    this.serchBiaoZhun();
    this.serchYingDu();
    this.serchCaiLiaoXinxi();
    this.serchYanSe();
  },


  methods: {
    bar_notShow() {
      this.PanDuanShou = false;
    },
    clearall() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.axios
          .get(httpUrl + `/api/index/offerDel?user_id=${selectID}`)
          .then((response) => {
            if (response.data.code === 200) {
              this.serchGouWuChe2();
              this.$message(response.data.message);
              console.log("success", response.data);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    delete(val) {
      this.axios
          .get(httpUrl + `/api/index/offerStrDel?id=${val}`)
          .then((response) => {
            if (response.data.code === 200) {
              this.serchGouWuChe2();
              this.$message(response.data.message);
              console.log("success", response.data);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    add(val) {
      this.axios
          .post(
              httpUrl + "/api/index/offerAdd",
              this.$qs.stringify({
                data: val,
              })
          )
          .then((response) => {
            if (response.data.code === 200) {
              this.$message("发送成功");
              console.log("success", response.data);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    TianJiaTest(item) {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      let stringTest = item;
      stringTest.user_id = selectID;
      console.log(stringTest);
      delete stringTest.child;
      let a = {};
      a = JSON.stringify(stringTest);
      this.add(a);
      console.log(stringTest);
      // console.log(a);
      // console.log(this.$refs.multipleTable.selection);
    },
    deletess(item) {
      let stringTest = item;
      console.log(stringTest);
      let a = {};
      delete stringTest.child;
      a = JSON.stringify(stringTest.id);
      this.delete(a);
      console.log(stringTest);
      console.log(a);
      // console.log(this.$refs.multipleTable.selection);
    },
    Second_jiage() {
      this.$router.push("/Main_menuPhone_JiaGeYuKuCun");
    },
    Second_ZhuDang() {
      this.$router.push("/ICChanPinXinXi_phone");
    },
    TableInputPhone() {
      this.$router.push("/TableInputPhone");
    },
    NeiBuXieTiao() {
      this.$router.push("/missionPhone");
    },
    serchGouWuChe2() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
          .get(
              httpUrl +
              `/api/index/offerList?page=${this.page}&user_id=${selectID}`
          )
          // .get(httpUrl+ `/api/user/nonStandardOfferList?page=${this.page}&user_id=${selectID}`)
          .then((response) => {
            if (response.data.code == 200) {
              this.PanDuanZhuangTai = 2;
              if (response.data.data.length > 100) {
                // this.$message(response.data.message);
              } else {
                response.data.data.map((value, key) => {
                  if (value.child.length > 0) {
                    value.child.map((val, num) => {
                      val["id"] = value.id * 10 + num;
                    });
                  }
                });
                this.tableData = response.data.data;
              }
            } else if (response.data.code == 401) {
              this.tableData = [];
            }
            // this.$message("搜索成功");
            // this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
    FinancePhone() {
      this.$router.push("/FinancePhone");
    },
    DingDanZhongXin() {
      this.$router.push("/OrderPlone");
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    back() {
      this.$router.push("/Main_menuPhone");
    },
    clearInput() {
      this.newItemNo = ""; //新料号
      this.oldMaterialNo = ""; //旧料号
      this.internal_meridian = ""; // 产品内径
      this.wire_diameter = ""; //产品线径
      this.ChanPinXiaoLei_choice = ""; //产品小类选择
      this.CaiZhi_choice = ""; //材质选择   //material
      this.BiaoZhun_Choice = ""; //标准选择
      this.YingDu_Choice = ""; //硬度选择
      this.standard_code = ""; //标准代码
      this.inquiry_no = ""; //询价单号
      this.CaiLiaoXinXi_Code_Choice = ""; //材料信息选择
      this.ChanPinDaLei_choice = ""; // 产品大类选择
      this.YanSe_Choice = ""; //颜色选择
    },
    inputShow() {
      if (this.PanDuanShous) {
        this.PanDuanShous = !this.PanDuanShous;
      } else {
        this.PanDuanShous = !this.PanDuanShous;
      }
    },
    navbarShow() {
      if (this.PanDuanShou) {
        this.PanDuanShou = !this.PanDuanShou;
      } else {
        this.PanDuanShou = !this.PanDuanShou;
      }
    },
    reflash(val) {
      this.page = val;
      this.serchFinanceinfo();
    },
    serchBiaoZhun() {
      this.axios
          .get(httpUrl + `/api/index/standard`)
          .then((response) => {
            if (response.data.code == 200) {
              this.BiaoZhun_Select = response.data.data;
              console.log(this.tableData.data);
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchYingDu() {
      this.axios
          .get(httpUrl + `/api/index/hardness`)
          .then((response) => {
            if (response.data.code == 200) {
              this.YingDu_Select = response.data.data;
              console.log(this.tableData.data);
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchCaiLiaoXinxi(vars) {
      this.axios
          .get(httpUrl + `/api/index/material_number?material=${vars}`)
          .then((response) => {
            if (response.data.code == 200) {
              this.CaiLiaoXinXi_Code_Select = response.data.data;
              console.log(this.tableData.data);
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchYanSe(vals) {
      this.axios
          .get(httpUrl + `/api/index/colorOffer?material=${vals}`)
          .then((response) => {
            if (response.data.code == 200) {
              this.YanSe_Select = response.data.data;
              console.log(this.tableData.data);
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchCaiZhi() {
      this.axios
          .get(
              httpUrl +
              `/api/index/standard_material?category_small=${this.ChanPinXiaoLei_choice}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.CaiZhi_select = response.data.data;
              console.log(this.tableData.data);
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchChanPinXiaoLei(val) {
      this.axios
          .get(
              httpUrl + `/api/index/standard_category?category_big=${val}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.ChanPinXiaoLei_Select = response.data.data;
              console.log(this.tableData.data);
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchChanPinDaLei() {
      this.axios
          .get(httpUrl + `/api/index/category`)
          .then((response) => {
            if (response.data.code == 200) {
              this.ChanPinDaLei_Select = response.data.data;
              console.log(this.tableData.data);
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchGouWuChe() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
          .get(httpUrl + `/api/index/offerList?user_id=${selectID}`)
          .then((response) => {
            if (response.data.code == 200) {
              this.PanDuanZhuangTai = 2;
              if (response.data.data.length > 100) {
                this.$message(response.data.message);
              } else {
                response.data.data.map((value, key) => {
                  if (value.child.length > 0) {
                    value.child.map((val, num) => {
                      val["id"] = value.id * 10 + num;
                    });
                  }
                });
                this.tableData = response.data.data;
              }
            } else if (response.data.code === 401) {
              this.tableData = [];
            }
            // this.$message("搜索成功");
            this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
    // serchChanPin() {
    //   let suser_id = JSON.parse(sessionStorage.getItem("user"));
    //   let selectID = suser_id.id;
    //   console.log(selectID);
    //   this.axios
    //     .get(
    //       httpUrl +
    //         `/api/index/offer?newItemNo=${this.newItemNo}&material=${this.CaiZhi_choice}&hardness=${this.YingDu_Choice}&standard_code=${this.standard_code}&color=${this.YanSe_Choice}&standard=${this.BiaoZhun_Choice}&material_number=${this.CaiLiaoXinXi_Code_Choice}&internal_meridian=${this.internal_meridian}&wire_diameter=${this.wire_diameter}&standard_code=${this.standard_code}&inquiry_no=${this.inquiry_no}&oldMaterialNo=${this.oldMaterialNo}&category_big=${this.ChanPinDaLei_choice}&category_small=${this.ChanPinXiaoLei_choice}&page=${this.page}&user_id=${selectID}`
    //     )
    //     .then((response) => {
    //       if (response.data.code == 200) {
    //         this.$message(response.data.message);
    //       } else {
    //         response.data.data.map((value, key) => {
    //           if (value.child.length > 0) {
    //             value.child.map((val, num) => {
    //               val["id"] = value.id * 10 + num;
    //             });
    //           }
    //         });
    //         this.tableData = response.data.data;
    //         console.log(this.tableData);
    //       }
    //       // this.$message("搜索成功");
    //       this.$message(response.data.message);
    //     })
    //     .catch((error) => console.log(error, "error"));
    // },
    serchChanPin() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
          .get(
              httpUrl +
              `/api/index/offer?newItemNo=${this.newItemNo}&material=${this.CaiZhi_choice}&hardness=${this.YingDu_Choice}&color=${this.YanSe_Choice}&standard_code=${this.BiaoZhun_Choice}&material_number=${this.CaiLiaoXinXi_Code_Choice}&internal_meridian=${this.internal_meridian}&wire_diameter=${this.wire_diameter}&&inquiry_no=${this.inquiry_no}&oldMaterialNo=${this.oldMaterialNo}&category_big=${this.ChanPinDaLei_choice}&category_small=${this.ChanPinXiaoLei_choice}&page=${this.page}&user_id=${selectID}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.PanDuanZhuangTai = 1;
              if (response.data.data.length > 100) {
                this.$message(response.data.message);
              } else {
                response.data.data.map((value, key) => {
                  if (value.child.length > 0) {
                    value.child.map((val, num) => {
                      val["id"] = value.id * 10 + num;
                    });
                  }
                });
                this.tableData = response.data.data;
              }
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            } else {
              this.tableData == [];
            }
            // this.$message("搜索成功");
            this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
    download() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
          .get(httpUrl + `/api/index/offerList?user_id=${selectID}`)
          .then((response) => {
            if (response.data.code == 200) {
              window.location.href =
                  httpUrl + `/api/index/excelUpdateOffer?user_id=${selectID}`;
              // this.tableData = response.data.data;
            }
            // this.$message("搜索成功");
            this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
  },
};
</script>

<style>
</style>

<style scoped>
.two_span_font {
  letter-spacing: 22px
}

.There_span {
  letter-spacing: 6px;
}

.Not_show {
  height: 260px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.all_firstbutton {
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.ChaKianQingDan {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}

.heads_menus {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu_icon img {
  width: 24px;
}

.list_div_div {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.all_part {
  min-height: 100vh;
  /*height: 100vh;*/
  background-color: #f2f2f2;
}

.head {
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;
  height: 45px;
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  position: fixed;
  z-index: 99;
}

.heads {
  padding-top: 40px;
  flex-direction: column;
  width: 42%;
  justify-content: space-around;
  display: flex;
  align-items: center;
  height: 300px;
  background-color: #ffffff;
  position: fixed;
  right: 0;
  z-index: 98;
  border-radius: 4px;
  box-shadow: 2px 1px 6px 6px #ccc;
}

.heads span {
  color: #000;
  font-size: 13px;
  line-height: 20px;
  font-weight: 250;
}

.heads_button {
  width: 70%;
  height: 40px;
  display: flex;

  align-items: center;
  justify-content: center;
}

.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}

.back img {
  margin-top: 5px;
}

.titleName {
  display: flex;
  justify-content: center;
}

.back {
  margin: 0 5px;
}

.all_input {
  width: 100%;
  position: fixed;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  height: 20%;
}

.all_inputs {
  width: 100%;
  position: fixed;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;

}

.all_input_tops {
  align-items: center;
  height: 70%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 10px;
}

.all_input_top {
  height: 15%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 10px;
}

.all_input_bottom {
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.all_input_top_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_top_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 15px;
}

.input {
  margin-bottom: 10px;
}

.all_key {
  display: flex;
  flex-direction: column;

}

.two_spans {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: aqua;
}

.Key {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 8pt;
  margin-bottom: 4px;
  justify-content: space-between;
}

.serch {
  width: 60%;
}

.list_div {
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  background-image: url("../assets/table_logo2.png");
  border-radius: 5px;
  padding: 10px 7px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}

.submit_button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /*margin-bottom: 20px;*/
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
}

.titleAndicon {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.title_icon {
  margin-right: 20px;
}

.sousuoButton {
  position: relative;
}

.sousuo_icon {
  top: 14px;
  left: 14px;
  position: absolute;
}

.ChongZhi {
  position: relative;
}

.icon_chong {
  top: 14px;
  left: 6px;
  position: absolute;
}

.ShouQi {
  margin-bottom: 10px;
}

.ShouQis {
  height: 20px;
  align-items: center;
  display: flex;
  flex-direction: column;
  transform: rotate(180deg);
  margin-bottom: 10px;
}

.icon_Shou {
  top: 14px;
  left: 12px;
  position: absolute;
}

.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}

.all_spans1 {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.all_spans {
  padding: 180px 10px 0 10px;

}

.all_spans2 {
  padding: 361px 10px 0 10px;
}

.titles {
  width: 100%;
  margin-top: 10px;
  display: flex;
}

.ss {
  height: 45px;
}

.XinJiuBianHao {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.second_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.double_span {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.double_spans {
  width: 48%;
}

.list_div_divs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}


.list_div {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding: 6px 14px;
  /* background-image: url(./../assets/img_cx_sylogo@2x.png); */
  background-size: 190px 102px;
}

.list_div_p_span {
  color: #008de3;
}

.list_div_span {
  color: #222222;
}

.list_div_p {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: left;
  margin: 6.5px 0;
}

.list_div_button {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: right;
  margin: 6.5px 0;
}
.list_div_divss{
  display: flex;
  flex-direction: row;
  text-align: left;
  margin-right: 10px;
}
.list_div_divsss{
  width: 100%;
  display: flex;
  flex-direction: row;
}
.Keys{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 12px;
  text-align: right;

}
.list_div_divsses
{
  display: flex;
  flex-direction: row;
  text-align: left;
  /* margin-right: 10px; */
  width: 100%;
  justify-content: space-between;

}
.Keyssss{
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 12px;
}
</style>